import React from 'react';

export const AudioContent: React.FC<{
  src: string;
}> = ({ src }) => {
  return (
    <audio className="w-full" src={src} controls>
      <source src={src} type="audio/ogg" />
      <source src={src} type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
  );
};
